import Vue from 'vue'
import App from './App.vue'
import 'lib-flexible/flexible'
import './assets/css/base.css'
import './assets/css/flex.css'
import './assets/css/reset.css'
import './assets/css/font.css'
import http from './assets/js/Http'

import Report from '@/assets/js/Report.js'
import PageId from "@/assets/js/PageId.js"

import router from './router'

Vue.config.productionTip = false
Vue.prototype.$http = http


router.afterEach((to, from) => {
  if (process.browser) {
    try {
      Report.init(true)
      Report.routerAfterEach(router.options.base,to, from)
    } catch (e) {
    }
  }
})

Vue.prototype.$report = Report

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
